
import React from 'react';
import { useEngagementPopups } from '@/hooks/useEngagementPopups';
import { PopupRenderer } from '@/components/popup-system/PopupRenderer';

export const EngagementMonitor = () => {
  const { popup, isVisible, dismissPopup } = useEngagementPopups();

  if (!popup || !isVisible) return null;

  return (
    <PopupRenderer
      content={{
        id: `engagement-${popup.type}-${Date.now()}`,
        title: popup.title,
        message: popup.message,
        style: popup.style,
        priority: popup.type === 'praise' ? 'high' : 'medium',
        dismissible: true,
      }}
      onDismiss={dismissPopup}
      onAction={(action) => {
        if (action === 'dismiss') dismissPopup();
      }}
    />
  );
};
